import React, { useState, useEffect } from "react";
import { func, bool, array, string, object } from "prop-types";
import { SocialShare } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import CloseIcon from "../atoms/icons/close";
import ShareIcon from "../atoms/icons/Share";
import { staticTexts } from "../utils/Translate";
import ShareAllTemplate from "../molecules/ShareAllTemplate";
import DfpAd from "../dfp-ad";
import ScrollSnap from "../atoms/ScrollSnap";
import RightArrowButton from "../atoms/icons/right-arrow-button";
import LeftArrowButton from "../atoms/icons/left-arrow-button";

import { getBreakingNews } from "../helper/api";
import { setTopAndBottomAd, setSocialShare, breakingNewsAd, setTopAd } from "../helper/actions";

import "./breakingNewsSlider.m.css";

const BreakingNewsSliderView = (props) => {
  const [breakingNews, setBreakingNews] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [isSocialShare, setIsSocialShare] = useState(false);
  const [closeAd, setCloseAd] = useState(true);
  const [isScroll, setIsScroll] = useState(false);
  const [adShow, setAdShow] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollUpPosition, setScrollUpPosition] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const selectionChange = (index) => setSelectedIndex(index);

  const breakingNewsApi = () => {
    getBreakingNews()
      .then((results) => {
        setOpenStatus(true);
        setBreakingNews(results);
      })
      .catch((err) => {
        console.log("Breaking API is not working" + err);
      });
  };

  useEffect(() => {
    breakingNewsApi();
    setInterval(breakingNewsApi, 120000);
    global.deviceWidth < 876 && setIsMobile(true);
  }, []);

  useEffect(() => {
    setScrollUpPosition(global.deviceWidth > 876 ? "90px" : "60px");

    document.addEventListener("scroll", () => {
      const isScrollAxis = scrollY > 200;
      if (global.deviceWidth > 876 && scrollY >= 400) {
        props.setTopAndBottomAd(true);
      } else if (global.deviceWidth < 876 && scrollY >= 300) {
        props.setTopAndBottomAd(true);
      } else {
        props.setTopAndBottomAd(false);
      }

      if (isScrollAxis !== isScroll) {
        setIsScroll(true);
        setAdShow(true);
      }
    });
    return () => {
      setBreakingNews([]);
      setOpenStatus(false);
      setIsSocialShare(false);
      setCloseAd(true);
      setIsScroll(true);
      setAdShow(false);
    };
  }, []);

  useEffect(() => {
    if (isSocialShare) {
      setIsSocialShare(false);
    }
  }, [selectedIndex]);

  const { publisherAttributes, pageType, showAd } = props;

  // breaking news logics : Start
  const closeBreaking = (storyId) => {
    localStorage.setItem("pabreak-key", storyId);
    setOpenStatus(false);
  };

  const shareBreaking = () => {
    setIsSocialShare((isSocialShare) => !isSocialShare);
    isMobile && props.setTopAd(!props.isTopAd);
  };

  // slider logics
  const processNewsElements = () => {
    const children = [];

    if (breakingNews && breakingNews.length > 0) {
      breakingNews.map((newsObj) => {
        newsObj && newsObj.metadata && newsObj.metadata["linked-story-slug"]
          ? children.push(
              <div styleName="breaking-share-elements">
                <a styleName="link" href={"/" + ((newsObj.metadata && newsObj.metadata["linked-story-slug"]) || "")}>
                  {newsObj.headline}
                </a>
              </div>
            )
          : children.push(<div styleName="link breaking-share-elements">{newsObj.headline}</div>);
      });
    }

    return children;
  };

  // current story ID cached to localstorage
  const storyRunningHead = breakingNews.slice(0, 1).map((stories) => stories.id.replace(",", " "));
  const storyHead = breakingNews.slice(0, breakingNews.length).map((stories) => stories.id.replace(",", " "));

  // localstorage cache headline
  let localCacheHead = [];
  if (typeof localStorage !== "undefined" && localStorage.getItem("pabreak-key") !== null) {
    localCacheHead = localStorage["pabreak-key"].split(",");
  }
  // breaking news logics : End

  // ADS logic Start
  const getAdType = () => {
    switch (pageType) {
      case "home-page":
        return publisherAttributes.lang === "en" ? "EnPalo_HP_Floating_970x90" : "Mobile_HP_Anchor";
      case "section-page":
        return publisherAttributes.lang === "en" ? "EnPalo_Inner_Floating_970x90" : "Mobile_Article_Anchor";
      case "collection-page":
        return publisherAttributes.lang === "en" ? "EnPalo_Inner_Floating_970x90" : "Mobile_Article_Anchor";
      case "story-page":
        return publisherAttributes.lang === "en" ? "EnPalo_Inner_Floating_970x90" : "Mobile_Article_Anchor";
      default:
        return publisherAttributes.lang === "en" ? "EnPalo_Inner_Floating_970x90" : "Mobile_Article_Anchor";
    }
  };
  const scrollUp = { bottom: showAd && closeAd ? scrollUpPosition : 0 };
  const scrollUpAd = { bottom: isScroll || adShow ? 0 : "-138px" };

  const closeAdBlock = () => {
    setCloseAd(false);
    props.breakingNewsAd(false);
  };
  // ADS logic End

  const currentBreakingNews = breakingNews[selectedIndex];

  const bottomAdComponent = () => (
    <div styleName={`ad-bottom ${showAd && closeAd ? "show-ad" : ""}`} style={scrollUpAd}>
      <div styleName="ad-bottom-wrapper">
        <div title="close" styleName="breaking-close ad-close" onClick={() => closeAdBlock()}>
          <CloseIcon />
        </div>
        <div styleName="ad-wrapper">
          <DfpAd adtype={getAdType()} slotId="breaking-news-slider-ad" />
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {breakingNews.length > 0 && openStatus && storyRunningHead.toString() !== localCacheHead[0] ? (
        <div styleName="breaking" style={scrollUp}>
          <div styleName="breaking-wrapper">
            <div title="close" styleName="breaking-close" onClick={() => closeBreaking(storyHead)}>
              <CloseIcon />
            </div>
            <div styleName="breaking-label">{staticTexts(publisherAttributes.lang).breakingNews}</div>
            <div styleName="breaking-share-elements">
              {currentBreakingNews &&
              currentBreakingNews.metadata &&
              currentBreakingNews.metadata["linked-story-slug"] ? (
                <div title="share" styleName="breaking-share" onClick={() => shareBreaking()}>
                  <ShareIcon />
                </div>
              ) : null}
              {isSocialShare &&
              currentBreakingNews &&
              currentBreakingNews.metadata &&
              currentBreakingNews.metadata["linked-story-slug"] ? (
                <SocialShare
                  template={ShareAllTemplate}
                  title={currentBreakingNews.headline}
                  url={encodeURI(currentBreakingNews.metadata["linked-story-slug"]) || ""}
                  toggleShare={shareBreaking}
                  isBreakingNews={true}
                />
              ) : null}
              <ScrollSnap
                leftArrow={<LeftArrowButton />}
                rightArrow={<RightArrowButton />}
                isIndicator={breakingNews.length > 1 && true}
                isArrow={false}
                selectionChange={selectionChange}
                isInfinite={true}
                interval={10000}
                pauseOnHover={true}
                customStyle={true}
              >
                {processNewsElements()}
              </ScrollSnap>
            </div>
          </div>
        </div>
      ) : null}
      {showAd && bottomAdComponent()}
    </div>
  );
};

BreakingNewsSliderView.propTypes = {
  breakingNews: array,
  publisherAttributes: object,
  setTopAndBottomAd: func,
  showAd: bool,
  pageType: string,
  isSocialShare: bool,
  setSocialShare: func,
  breakingNewsAd: func,
  setTopAd: func,
  isTopAd: bool,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  showAd: get(state, ["TopAndBottomAdReducer", "showAd"], false),
  pageType: get(state, ["qt", "pageType"], ""),
  isSocialShare: get(state, ["socialShareReducer", "isSocialShare"], false),
  isTopAd: get(state, ["topAdReducer", "isTopAd"], true),
});

const mapDispatchToProps = (dispatch) => ({
  setTopAndBottomAd: (flag) => dispatch(setTopAndBottomAd(flag)),
  breakingNewsAd: (flag) => dispatch(breakingNewsAd(flag)),
  setSocialShare: (flag) => dispatch(setSocialShare(flag)),
  setTopAd: (flag) => dispatch(setTopAd(flag)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BreakingNewsSliderView);
